import {NAV_BAR_MOBILE_HEIGHT} from '@vio/atlas/NavBar'
import {useBrand} from '@vio/core/src/_web/brand/hooks/useBrand'
import {useBrandCapabilities} from '@vio/core/src/_web/brand/hooks/useBrandCapabilities'
import {BrandCode} from '@vio/core/src/brand/types'
import {
  FINN_CUSTOM_HEADER_HEIGHT,
  HOLIDAY_PIRATES_CUSTOM_HEADER_HEIGHT,
  KIWI_CUSTOM_HEADER_HEIGHT,
  KIWI_CUSTOM_HEADER_HEIGHT_MOBILE
} from '@vio/shared/src/whiteLabel/CustomHeader'

const CUSTOM_HEADER_HEIGHTS: Partial<
  Record<BrandCode, {desktop: number; mobile: number}>
> = {
  finn: {desktop: FINN_CUSTOM_HEADER_HEIGHT, mobile: FINN_CUSTOM_HEADER_HEIGHT},
  holidaypiratesde: {
    desktop: HOLIDAY_PIRATES_CUSTOM_HEADER_HEIGHT,
    mobile: HOLIDAY_PIRATES_CUSTOM_HEADER_HEIGHT
  },
  kiwi: {
    desktop: KIWI_CUSTOM_HEADER_HEIGHT,
    mobile: KIWI_CUSTOM_HEADER_HEIGHT_MOBILE
  }
}

export const useTopHeaderHeight = (isMobile = false) => {
  const {brandCode} = useBrand()
  const {shell} = useBrandCapabilities()

  if (shell.hasCustomHeader) {
    const heights = CUSTOM_HEADER_HEIGHTS[brandCode]
    if (heights) return isMobile ? heights.mobile : heights.desktop
  }

  if (isMobile) return 0

  return NAV_BAR_MOBILE_HEIGHT
}
